

function InMemoryStorage() {}

InMemoryStorage.prototype.setItem = function (key, value) {
	this[key] = value;
};

InMemoryStorage.prototype.getItem = function (key) {
	return typeof this[key] !== undefined ? this[key] : undefined;
};

InMemoryStorage.prototype.removeItem = function (key) {
	delete this[key];
};

InMemoryStorage.prototype.clear = function () {
	for (const key in this) {
		if (this.hasOwnProperty(key)) {
			this.removeItem(key);
		}
	}
};

InMemoryStorage.prototype.key = function (index) {
	return Object.keys(this)[index];
};

InMemoryStorage.prototype.count = function () {
	return Object.keys(this).length;
};

module.exports = InMemoryStorage;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/localStorage/in-memory-storage.js
 **/